import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import {
  requestAllCategories,
  requestCampaigns,
} from 'services/actions/adminActions';
import AdminRoutes from 'routes/AdminRoutes';
import Navbar from './Navbar/Navbar';

const MainPage = ({ getCampaigns, getAllCategories }) => {
  useEffect(() => {
    getCampaigns();
    getAllCategories();
  }, []);

  return (
    <>
      <Navbar />
      <AdminRoutes />
    </>
  );
};

const mapDispatchToProps = {
  getCampaigns: requestCampaigns,
  getAllCategories: requestAllCategories,
};

export default connect(null, mapDispatchToProps)(MainPage);
